/* eslint-disable */
/* eslint-disable no-underscore-dangle */
import { REFRESH_TOKEN_INTERVAL } from 'appConstants';
import { fetchTokenInfo } from './Api/user';

/**
 * Class for managing user's session
 * this is just a temporary solution for
 * as long as we support legacy auth.
 *
 * After all users have migrated to IAM (auth0)
 * we can safely remove this logic.
 */
class Session {
  constructor() {
    this.intervalId = null;
    this.refreshTokenInterval = this.refreshTokenInterval.bind(this);
    this.clearRefreshTokenInterval = this.clearRefreshTokenInterval.bind(this);
    this._isActive = true;
  }

  refreshTokenInterval() {
    if (!this.intervalId) {
      this.intervalId = setInterval(() => {
        if (this._isActive) {
          fetchTokenInfo();
        }
      }, REFRESH_TOKEN_INTERVAL);
    }
  }

  clearRefreshTokenInterval() {
    clearInterval(this.intervalId);
    this._isActive = false;
  }

  get isActive() {
    return this._isActive;
  }

  set isActive(bool) {
    this._isActive = bool;
  }
}

const session = new Session();
export { session };
